import * as React from "react";
import { Item, type FsEntryPermissionEntry } from "@/types/fse";
import { ShareModalUserRow } from "@/views/drive/modals/shareModal/usersRow";

interface ShareModalUsersProps {
  permissions: FsEntryPermissionEntry[];
  item: Item;
  isReadOnly: boolean;
}

export const ShareModalUsers: React.FC<ShareModalUsersProps> = ({ isReadOnly, item, permissions }) => (
  <div className="mt-3">
    <h4 className="mb-2 text-sm font-semibold">People with access</h4>

    {permissions.map(permission => (
      <ShareModalUserRow key={permission.id} permission={permission} isReadOnly={isReadOnly} item={item} />
    ))}
  </div>
);
